export enum AptLineType {
    Option = 'Option',
    ProductService = 'Product/Service',
    Misc = 'Misc',
}
